import { AUTH_CONFIG } from "@/config/auth";

// API URL Configuration for AI Transform
export const API_ENDPOINTS = {
  // Authentication endpoints (routed through proxy)
  auth: {
    authorization: AUTH_CONFIG.endpoints.authorization,
    me: AUTH_CONFIG.endpoints.me,
    userinfo: AUTH_CONFIG.endpoints.userinfo,
    logout: AUTH_CONFIG.endpoints.logout,
    refresh: AUTH_CONFIG.endpoints.refresh,
  },

  // AI Transform API endpoints (actual endpoints that exist)
  aiTransform: {
    base: "/api/ai-transform",
  },

  // Gateway endpoints
  gateway: {
    base: "/api",
    health: "/api/health",
  },
} as const;

// Helper function to build API URLs
export function buildApiUrl(
  endpoint: string,
  params?: Record<string, string>
): string {
  let url = endpoint;

  if (params) {
    const searchParams = new URLSearchParams(params);
    url += `?${searchParams.toString()}`;
  }

  return url;
}

// Helper function to get auth headers
export function getAuthHeaders(): HeadersInit {
  const headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  // Add authorization header if available
  if (typeof window !== "undefined") {
    const token =
      localStorage.getItem("auth_token") ||
      sessionStorage.getItem("auth_token");
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
  }

  return headers;
}

export type ApiEndpoints = typeof API_ENDPOINTS;
